// extracted by mini-css-extract-plugin
export default {"express_checkout":"sx","buttons":"tx","stripe":"ux","or_title":"vx","line":"wx","express_checkout_title":"xx","center_block":"yx"};
    if(module.hot) {
      // 1711394578343
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  